import { AxiosResponse } from "axios";
import { IGetAttractedUsersRequest, IGetAttractedUsersResults, IGetUsersRequest, IGetUsersResults, IListUserTransactionsRequest, IUpdateUserProfileRequest, IUser, IUserAccrualRequest } from "./types";
import { apiInstance } from "../base";
import { IBonusTransactionsAggregates, IGetBonusTransactions } from "../bonuses";
import { IBonusAccrualResponse } from "@/shared/types";

export const getUsers = (data: IGetUsersRequest): Promise<AxiosResponse<IGetUsersResults>> => {
    return apiInstance.handler.get(`/users`, {
        params: {
            page: data.page,
            limit: data.limit,
            search: data.search,
            role_id: data.role_id,
            with_balances: data.with_balances,
            all: data.all,
            group_id: data.group_id,
            block_status: data.block_status,
            deleted_status: data.deleted_status,
            attracted: data.attracted === 'all' ? undefined : data.attracted
        }
    })
}

export const getAttractedUsers = (data: IGetAttractedUsersRequest): Promise<AxiosResponse<IGetAttractedUsersResults>> => {
    return apiInstance.handler.get<IGetAttractedUsersResults>(`/users/attracted`, {
        params: {
            page: data.page,
            limit: data.limit,
            partner_id: data.partner_id,
            attracted_from: data.attracted_from,
            attracted_to: data.attracted_to
        }
    })
}

export const blockUser = (id: string): Promise<AxiosResponse<IUser>> => {
    return apiInstance.handler.post<IUser>(`/users/${id}/block`)
}

export const unblockUser = (id: string): Promise<AxiosResponse<IUser>> => {
    return apiInstance.handler.post<IUser>(`/users/${id}/unblock`)
}

export const getUser = (id: string): Promise<AxiosResponse<IUser>> => {
    return apiInstance.handler.get<IUser>(`/users/${id}`)
}

export const getUserTransactions = (id: string, data: IListUserTransactionsRequest): Promise<AxiosResponse<IGetBonusTransactions>> => {
    return apiInstance.handler.get<IGetBonusTransactions>(`/users/${id}/transactions`, {
        params: {
            page: data.page,
            per_page: data.limit,
            date_from: data.startDate,
            date_to: data.endDate,
            with_total_count: 1,
            bonus_id: data.bonusId
        }
    })
}

export const getUserTransactionAggregates = (id: string, startDate: Date, endDate: Date): Promise<AxiosResponse<IBonusTransactionsAggregates>> => {
    return apiInstance.handler.get<IBonusTransactionsAggregates>(`/users/${id}/transactions-statistics`, {
        params: {
            interval: 'day',
            date_from: startDate.toISOString(),
            date_to: endDate.toISOString()
        }
    })
}

export const userAccrual = (userId: string, data: IUserAccrualRequest): Promise<AxiosResponse<IBonusAccrualResponse>> => {
    return apiInstance.handler.post(`/users/${userId}/accrual`, data)
}

export const userHasCard = (userId: string): Promise<AxiosResponse<{ has_card: boolean }>> => {
    return apiInstance.handler.get<{ has_card: boolean }>(`/users/${userId}/has-card`)
}

export const deleteUser = (id: string): Promise<AxiosResponse<IUser>> => {
    return apiInstance.handler.post<IUser>(`/users/${id}/delete`)
}

export const recoverUser = (id: string): Promise<AxiosResponse<IUser>> => {
    return apiInstance.handler.post<IUser>(`/users/${id}/recover`)
}

export const updateUserProfile = (userId: string, data: IUpdateUserProfileRequest): Promise<AxiosResponse<IUser>> => {
    const formData = new FormData()
    if (data.name !== undefined && data.name !== '') formData.append('name', data.name)
    if (data.email !== undefined && data.email !== '') formData.append('email', data.email)
    if (data.date_of_birth !== undefined && data.date_of_birth !== '') formData.append('date_of_birth', data.date_of_birth)
    if (data.gender !== undefined) formData.append('gender', data.gender)
    return apiInstance.handler.put<IUser>(`/users/${userId}/profile`, formData)
}
